import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: false
})
export class FileSizePipe implements PipeTransform {
  units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  transform(bytes: number, precision: number): string {
    // validate 'bytes'
    if (isNaN(bytes)) {
      return '-';
    }
    if (bytes < 1) {
      return '0 B';
    }

    // validate 'precision'
    if (isNaN(precision)) {
      precision = 1;
    }

    const unitIndex = Math.floor(Math.log(bytes) / Math.log(1000));
    const value = bytes / Math.pow(1000, unitIndex);

    return value.toFixed(precision) + ' ' + this.units[unitIndex];
  }
}
